import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Checkbox,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
} from '@mui/material';
import helpers from 'src/helpers';
import {
  getAbbreviatedTimeZone,
  getBrowserIana,
} from 'src/helpers/formOptions';

function THeadResults({
  classes,
  scheduledMessages,
  selectedScheduledMessages,
  setSelectedScheduledMessages,
  onChangeSortBy,
  query,
}) {
  const { sort, status } = query || {};
  const isViewingSent = status === 'sent';
  const sortBy = helpers.transform.toSortFieldObj(sort);

  const getNextSortAscDesc = (currentValue) => (currentValue && currentValue === 'asc' ? 'desc' : 'asc');
  const getCurrentSortAscDesc = (currentValue) => (currentValue || 'asc');

  const browsertzAbbreviated = getAbbreviatedTimeZone(getBrowserIana());

  const areAllMessagesSelected = () => {
    if (helpers.isEmpty(scheduledMessages)) {
      return false;
    }
    const newSelectedMessages = helpers.transform.toArray(selectedScheduledMessages);
    const newMessages = helpers.transform.toArray(scheduledMessages);

    return !!(newSelectedMessages.length === newMessages.length && newMessages.find((messageItem) => messageItem?.id && newSelectedMessages.find((selectedMessageItem) => selectedMessageItem.id === messageItem?.id)));
  };

  const areAllMessagesSelectedVal = areAllMessagesSelected();

  const handleSelectAllMessages = () => {
    setSelectedScheduledMessages(
      !areAllMessagesSelectedVal
        ? helpers.transform.toArray(scheduledMessages).map((item) => ({ id: item?.id, type: item?.messageType }))
        : []
    );
  };

  const handleChangeSortBy = (value, current) => {
    onChangeSortBy(current === 'desc' ? [] : value);
  };

  return (
    <TableHead className={classes.tableHead}>
      <TableRow>
        {!isViewingSent && (
          <TableCell>
            <Checkbox
              checked={areAllMessagesSelectedVal}
              onChange={handleSelectAllMessages}
              color="secondary"
            />
          </TableCell>
        )}

        <TableCell>
          <TableSortLabel
            active={!!sortBy?.dateTime}
            direction={getCurrentSortAscDesc(sortBy?.dateTime)}
            onClick={() => {
              handleChangeSortBy(
                [
                  ['dateTime', getNextSortAscDesc(sortBy?.dateTime)],
                ],
                getCurrentSortAscDesc(sortBy?.dateTime)
              );
            }}
          >
            {isViewingSent ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                <span>
                  Date & Time Scheduled
                  <Typography
                    component="span"
                    variant="caption"
                    sx={{ color: 'text.secondary' }}
                  >
                    {' '}
                    (
                    {browsertzAbbreviated}
                    )
                  </Typography>
                </span>
                <span style={{ color: '#4caf50' }}>
                  Date & Time Sent
                  <Typography
                    component="span"
                    variant="caption"
                    sx={{ color: 'text.secondary' }}
                  >
                    {' '}
                    (
                    {browsertzAbbreviated}
                    )
                  </Typography>
                </span>
              </Box>
            ) : (
              <span>
                Date & Time to Send
                <Typography
                  component="span"
                  variant="caption"
                  sx={{ color: 'text.secondary' }}
                >
                  {' '}
                  (
                  {browsertzAbbreviated}
                  )
                </Typography>
              </span>
            )}
          </TableSortLabel>
        </TableCell>

        <TableCell className={classes.nowrap}>
          Type of Connection
        </TableCell>

        <TableCell align="center">
          Contacts
        </TableCell>

        <TableCell className={classes.textMessages}>
          Text Message To Send
        </TableCell>

        <TableCell
          align="left"
          className={classes.image}
        >
          Attachments
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

THeadResults.propTypes = {
  classes: PropTypes.object.isRequired,
  onChangeSortBy: PropTypes.func.isRequired,
  setSelectedScheduledMessages: PropTypes.func.isRequired,
  selectedScheduledMessages: PropTypes.array.isRequired,
  query: PropTypes.object,
  scheduledMessages: PropTypes.array,
};
THeadResults.defaultProps = {
  query: {},
  scheduledMessages: [],
};

export default THeadResults;
